import React, {FC} from 'react';
import cn from 'classnames';
import {useLocalizer} from '@/common/services/localizer';
import styles from './ConditionSmallIcon.css';

interface ConditionSmallIconProps {
	className?: string;
	condition: number;
	isNight?: boolean;
}

export const ConditionSmallIcon: FC<ConditionSmallIconProps> = props => {
	const {className, condition, isNight} = props;

	const t = useLocalizer();

	return (
		<div
			className={cn(
				styles.root,
				isNight ? styles.periodNight : styles.periodDay,
				styles[`condition${condition}`],
				className,
			)}
			aria-label={t(`weatherConditions.${condition}`)}
		/>
	);
};

ConditionSmallIcon.displayName = 'ConditionSmallIcon';
